import { Button } from "rsuite";
import { BreadCrumbSign } from "../../components/generic/breadcrumbSign.component";
import Reganalytics from "./../../assets/images/Reganalytics.png";
import { AppRoutesUI } from "../../config/appRoutes";
import { Link } from "react-router-dom";
import { useAppSelector } from "../../core/redux";
import { ProfileTable } from "../../components/generic/profileTable/profileTableComponent";
import { useState, useEffect } from "react";
import { ApiSchemaSuperAdmin } from "../../models/api/apiSchemaSuperAdmin";
import { ApiAuth } from "../../core/apis/auth";

export const AdminProfilePage = () => {
  const { email } = useAppSelector((state) => state.auth);
  const [data, setData] = useState<ApiSchemaSuperAdmin>();
  useEffect(() => {
    getProfileInfo();
  }, []);
  const getProfileInfo = async () => {
    ApiAuth.getProfileInfo().then((res) => {
      setData(res.Data);
    });
  };
  return (
    <div className="row gx-0">
      <div className="col-12 m-2">
        <div className="d-flex flex-column ms-1 px-1">
          <p className="content-header ms-1">
            Admin <BreadCrumbSign /> View
          </p>
          <div className="profile-card col-12">
            <div className="row gx-0">
              <div className="d-flex flex-column align-items-center justify-content-center col-12 col-md-4">
                <div>
                  <img src={Reganalytics} alt="Reganalytics Logo"></img>
                </div>
                <div
                  className="d-flex flex-column
            align-items-center pb-2"
                >
                  <p className="fs-7">{email}</p>
                  <strong className="fs-7">Admin</strong>
                </div>
              </div>
              <div className="d-flex flex-column col-12 col-md-8">
                <ProfileTable data={data} />
                <div className="ms-5">
                  <Link to={AppRoutesUI.Admins.AdminProfileEditById(data?.Id ?? "")} state={data?.Id ?? ""}>
                    <Button appearance="primary" className="profile-edit-button mb-4">
                      Edit
                    </Button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
